import { Text, View, Image } from '@react-pdf/renderer';
import { S3_URL } from 'constants/index';
import { checkObjHasValues, convertToPng } from 'utils';

const Language = ({ styles, data, headerTitle }: any) => {
	return (
		<View style={styles.mainBox}>
			<Text style={styles.heading}>{headerTitle}</Text>

			<View style={styles.mainBoxInner}>
				{data?.map((res: any) => {
					if (checkObjHasValues(res)) {
						return (
							<View key={`lang-${res?.name}-${res?.proficiency}`} style={styles.detailBox}>
								{res?.image && (
									<View>
										<Image style={styles.detailIcon} src={convertToPng(S3_URL + res.image)} />
									</View>
								)}
								<View>
									<Text style={styles.detailText}>
										{res?.name} - {res?.proficiency}
									</Text>
								</View>
							</View>
						);
					}
				})}
			</View>
		</View>
	);
};

export default Language;
